import { PersonIdentificationDto, SampleSystemModel, PersonSampleDto, PersonDto, ClientResources } from '@app/api2/api';
import { isNullEmptyObject, isNullOrWhitespace } from '@app/components/React/Common/Utils';
import * as Yup from 'yup';
import { SampleKeyboardInputSchema } from './SampleKeyboardInput.Schema';

export type IdentificationTypeMembers = Pick<PersonDto, 'id' | 'identifications' | 'samples'>;

export const IdentificationSchema: (t: ClientResources) => Yup.SchemaOf<IdentificationTypeMembers> = (t) => Yup.object({
    id: Yup.number().optional().meta({ search: false }),
    identifications: Yup.array().of(
        Yup.object({
            idTypeId: Yup.number().label(t.metadata.idTypeLabel || 'ID Type').required(),
            idNumber: Yup.string().label(t.metadata.idNumberLabel || 'ID Number').max(100).required(),
            idCountryId: Yup.number().label(t.metadata.idCountryLabel || 'Country of issuance').required(),
            id: Yup.number().optional().nullable().meta({ search: false }),
            idStateId: Yup.number().label(t.metadata.idStateLabel || 'State of issuance').optional().nullable(),
        }) as Yup.SchemaOf<PersonIdentificationDto>
    ).label(t.metadata.identificationsLabel || 'Identifications'),
    samples: Yup.array().of(
        Yup.object().shape({
            id: Yup.number().optional().nullable().meta({ search: false }),
            alleleFormat: Yup.mixed().required().label(t.metadata.alleleFormatLabel || 'Allele Format').meta({ search: false }),
            collectorId: Yup.string().label(t.metadata.collectorLabel || 'Collector').nullable().optional(),
            collectorName: Yup.string().label(t.metadata.collectorNameLabel || 'Collector Name').max(180).optional().nullable().meta({ search: false }),
            collectionDate: Yup.date().label(t.metadata.collectionDateLabel || 'Collection Date').nullable().required().test('future-date', t.metadata.collectionDateFuture || 'Collection Date cannot be in the future', (value) => {
                return value && value <= new Date();
            }) as any,
            kitId: Yup.number().label(t.metadata.kitLabel || 'Kit').nullable().required().meta({ search: false }),
            sampleId: Yup.number().nullable().optional().meta({ search: false }),
            sampleName: Yup.string().label(t.metadata.sampleNameLabel || 'Sample Name').max(100).optional().nullable(),
            andeSwabId: Yup.string().label(t.metadata.andeSwabIdLabel || 'ANDE Swab ID').max(18).nullable().optional(),//.required('ANDE Swab ID is required').matches(/^\d{13}_[A-Z]{4}$/, 'Invalid ANDE Swab ID.'),

            keyboardSample: SampleKeyboardInputSchema.label(t.metadata.dnaProfileLabel || 'DNA Profile').nullable().required().meta({ search: { flat: true } }),
        }) as Yup.SchemaOf<PersonSampleDto>
    ).max(1, t.metadata.onlyOneSampleAllowed || 'Only one sample is allowed').label(t.metadata.samplesLabel || 'Samples'),
});

type IdentificationTypeMembersObject = Record<(keyof IdentificationTypeMembers), undefined>;

const identificationDefProperties: IdentificationTypeMembersObject = {
    id: undefined,
    identifications: undefined,
    samples: undefined,
};

export const ALL_IDENTIFICATION_PROPERTIES = Object.keys(identificationDefProperties) as (keyof IdentificationTypeMembers)[];

